var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-icons"},[_c('router-view',{attrs:{"sets":_vm.sets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }